module.exports = __webpack_public_path__ + "static/cuidarme-amarme-720b2369320f1900747b39026416be93.png";